var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E8EEF2",
    d: "M41.338 28.763L37.388 24.831 31.404 30.786 26.459 38.017 28.604 41.437 38.427 31.66z",
    transform: "translate(-685.000000, -320.000000) translate(430.000000, 288.000000) translate(255.000000, 32.001200) translate(9.000000, 9.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D3DAE0",
    d: "M14.043 27.736l-6.315 6.286c-2.877 2.863-2.85 7.537.08 10.366 2.879 2.78 7.497 2.665 10.333-.157l9.66-9.615c2.854-2.84 2.854-7.446 0-10.287l-.06-.06c-1.092-1.087-1.092-2.847 0-3.933 1.09-1.086 2.859-1.086 3.95 0l.061.061c5.036 5.012 5.036 13.139 0 18.151l-9.739 9.693c-5.035 5.012-13.2 5.012-18.236 0-5.036-5.012-5.036-13.139 0-18.151l9.796-9.75 8.85-8.81 2.926 2.912-6.416 6.277.228 2.156-5.118 4.86z",
    transform: "translate(-685.000000, -320.000000) translate(430.000000, 288.000000) translate(255.000000, 32.001200) translate(9.000000, 9.000000)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#899EA8",
    d: "M24.946 14.041l-2.522-2.51-8.851 8.809-9.796 9.75c-5.036 5.012-5.036 13.139 0 18.15.979.975 2.074 1.759 3.243 2.355-.097-.091-.19-.183-.285-.277-5.036-5.012-5.036-13.139 0-18.151l6.185-6.156c.64-.638 1.743-.358 1.983.511l.09.312 2.828-2.686v-3.015l7.125-7.092z",
    transform: "translate(-685.000000, -320.000000) translate(430.000000, 288.000000) translate(255.000000, 32.001200) translate(9.000000, 9.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E8EEF2",
    d: "M37.388 24.83l3.95 3.933 6.885-6.853c5.036-5.012 5.036-13.139 0-18.15-5.036-5.013-13.2-5.013-18.236 0l-9.739 9.692c-5.036 5.012-5.036 13.139 0 18.151l.061.061c1.091 1.086 2.86 1.086 3.951 0 1.09-1.086 1.09-2.846 0-3.932l-.061-.061c-2.854-2.84-2.854-7.446 0-10.287l9.66-9.615c2.836-2.822 7.454-2.936 10.333-.157 2.93 2.829 2.957 7.503.08 10.366l-6.315 6.286-.57.567z",
    transform: "translate(-685.000000, -320.000000) translate(430.000000, 288.000000) translate(255.000000, 32.001200) translate(9.000000, 9.000000)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#D3DAE0",
    d: "M23.727 14.157l9.738-9.693C36.192 1.75 39.835.507 43.403.73 38.867-.86 33.615.148 29.987 3.76l-9.739 9.693c-5.036 5.012-5.036 13.139 0 18.151l.061.061c.886.882 2.22 1.048 3.274.497-4.891-5.023-4.844-13.04.144-18.004z",
    transform: "translate(-685.000000, -320.000000) translate(430.000000, 288.000000) translate(255.000000, 32.001200) translate(9.000000, 9.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnect);
export default __webpack_public_path__ + "static/media/connect.88dd89ab.svg";
export { ForwardRef as ReactComponent };